import { defineMessages } from 'react-intl';

/** The copy of the Studio "Your profile" card (design profile-card a) and the Kit tab shortcut (design artist-profile c3). */
export const profileEntryMessages = defineMessages({
  title: { id: 'app.sml.promote.profile.entry.title', defaultMessage: 'Your profile' },
  eyebrow: {
    id: 'app.sml.promote.profile.entry.eyebrow',
    defaultMessage: 'Your profile · for you, not for one song',
  },
  titleSome: {
    id: 'app.sml.promote.profile.entry.titleSome',
    defaultMessage: 'One look on every page where fans find you.',
  },
  titleDone: { id: 'app.sml.promote.profile.entry.titleDone', defaultMessage: 'Your profile is live everywhere.' },
  subSome: {
    id: 'app.sml.promote.profile.entry.subSome',
    defaultMessage: '{ready} of {total} ready. Make the {list} to finish the set.',
  },
  subMaking: {
    id: 'app.sml.promote.profile.entry.subMaking',
    defaultMessage: '{count, plural, one {The {list} is} other {The {list} are}} on the way. About 10 seconds.',
  },
  subDone: {
    id: 'app.sml.promote.profile.entry.subDone',
    defaultMessage:
      'The same look on Spotify, YouTube and Facebook. Your next release can give it a new look in one click.',
  },
  subEmpty: {
    id: 'app.sml.promote.profile.entry.subEmpty',
    defaultMessage:
      'Your Spotify header and your YouTube and Facebook banners, in the cover and colours of your newest release. Free, about 20 seconds.',
  },
  ready: { id: 'app.sml.promote.profile.entry.ready', defaultMessage: '<b>{ready}</b> of {total} ready' },
  readyLoading: { id: 'app.sml.promote.profile.entry.readyLoading', defaultMessage: '<b>–</b> of {total} ready' },
  cardOpenProfile: { id: 'app.sml.promote.profile.entry.openProfile', defaultMessage: 'Open profile' },
  kindSpotifyHeader: { id: 'app.sml.promote.profile.entry.kind.spotifyHeader', defaultMessage: 'Spotify header' },
  kindSpotifyAvatar: { id: 'app.sml.promote.profile.entry.kind.spotifyAvatar', defaultMessage: 'artist photo' },
  kindYoutubeBanner: { id: 'app.sml.promote.profile.entry.kind.youtubeBanner', defaultMessage: 'YouTube banner' },
  kindFacebookCover: { id: 'app.sml.promote.profile.entry.kind.facebookCover', defaultMessage: 'Facebook cover' },
  kindPressPhoto: { id: 'app.sml.promote.profile.entry.kind.pressPhoto', defaultMessage: 'press photo' },
  tileSpotifySize: { id: 'app.sml.promote.profile.entry.tile.spotifySize', defaultMessage: 'Header + photo' },
  tileYoutubeSize: { id: 'app.sml.promote.profile.entry.tile.youtubeSize', defaultMessage: '2560 x 1440' },
  tilePressSize: { id: 'app.sml.promote.profile.entry.tile.pressSize', defaultMessage: '3:2 · 4:5 · 1:1' },
  tileBioSize: { id: 'app.sml.promote.profile.entry.tile.bioSize', defaultMessage: 'Short + long' },
  bioEmpty: {
    id: 'app.sml.promote.profile.entry.bioEmpty',
    defaultMessage: 'No bio yet. We write a draft from your songs.',
  },
  sendToSpotify: { id: 'app.sml.promote.profile.entry.sendToSpotify', defaultMessage: 'Send to Spotify' },
  connectSpotify: { id: 'app.sml.promote.profile.entry.connectSpotify', defaultMessage: 'Connect Spotify' },
  signInAgain: { id: 'app.sml.promote.profile.entry.signInAgain', defaultMessage: 'Sign in again' },
  upgradeToSend: { id: 'app.sml.promote.profile.entry.upgradeToSend', defaultMessage: 'Upgrade to send' },
  make: { id: 'app.sml.promote.profile.entry.make', defaultMessage: 'Make' },
  addPhoto: { id: 'app.sml.promote.profile.entry.addPhoto', defaultMessage: 'Add a photo' },
  cardLabel: { id: 'app.sml.promote.profile.entry.cardLabel', defaultMessage: 'Your profile images and bio' },
  kitUseTitle: { id: 'app.sml.promote.profile.kit.use.title', defaultMessage: 'Use this release for my profile' },
  kitUseBody: {
    id: 'app.sml.promote.profile.kit.use.body',
    defaultMessage:
      'Make your Spotify header and your YouTube and Facebook banners from the cover of {title}. Free. Your profile keeps the old versions.',
  },
  kitUseIt: { id: 'app.sml.promote.profile.kit.use.button', defaultMessage: 'Use it' },
  kitUseDone: {
    id: 'app.sml.promote.profile.kit.use.done',
    defaultMessage: 'Your profile makes them now. About 20 seconds.',
  },
  useForProfile: { id: 'app.sml.promote.profile.kit.useForProfile', defaultMessage: 'Use for my profile' },
  openProfile: { id: 'app.sml.promote.profile.kit.openProfile', defaultMessage: 'Open Profile' },
  inYourProfile: { id: 'app.sml.promote.profile.kit.inYourProfile', defaultMessage: 'In your profile' },
  useForProfileDone: {
    id: 'app.sml.promote.profile.kit.useForProfileDone',
    defaultMessage: 'Your profile makes this header now.',
  },
});
